import * as XLSX from 'xlsx';

export interface ExcelColumn<T> {
  header: string;
  accessor: (item: T) => string | number;
}

export function exportToExcel<T>(
  data: T[],
  columns: ExcelColumn<T>[],
  fileName: string
): void {
  const headers = columns.map(function getHeader(col) {
    return col.header;
  });

  const rows = data.map(function mapRow(item) {
    return columns.map(function mapCell(col) {
      return col.accessor(item);
    });
  });

  const worksheetData = [headers, ...rows];
  const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Dados');

  const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
  const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
  const url = URL.createObjectURL(blob);

  const link = document.createElement('a');
  link.href = url;
  link.download = `${fileName}.xlsx`;
  link.click();

  URL.revokeObjectURL(url);
}
